<template>
  <div>
    <BuyerCampaignsList
      :buyer-campaigns="buyerCampaigns"
      :campaign-spend-data="campaignSpend"
      :is-loading="isLoading"
    />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

import BuyerCampaignsList from './BuyerCampaignsList.vue'

export default {
  name: 'BuyerCampaigns',

  title: 'Buyer Campaigns',

  components: {
    BuyerCampaignsList
  },

  data() {
    return {
      type: '',
      isLoading: false
    }
  },

  computed: {
    ...mapState('campaign', ['buyerCampaigns']),
    ...mapState('insights', ['campaignSpend'])
  },

  async created() {
    await this.getCampaigns()
  },

  methods: {
    ...mapActions('campaign', ['fetchBuyerCampaigns']),
    ...mapActions('insights', ['fetchCampaignSpend']),

    async getCampaigns() {
      try {
        this.isLoading = true
        await Promise.all([
          this.fetchBuyerCampaigns({ detailed: false }),
          this.fetchCampaignSpend().catch(() => {})
        ])
      } catch (error) {
        //
      } finally {
        this.isLoading = false
      }
    },
  }
}
</script>

<style></style>
